// OSIS - Stocuri rășini epoxidice și Aluminiu  
import React, { useState } from 'react';
import { 
  Layers, 
  Search, 
  Filter, 
  Plus,
  AlertTriangle,
  Package,
  Truck,
  Eye,
  Edit,
  BarChart3,
  Palette
} from 'lucide-react';
import Card from '../../components/Card';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const ProfilesStock = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedMaterial, setSelectedMaterial] = useState('toate');
  const [selectedBrand, setSelectedBrand] = useState('toate');
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState(null);

  // Stocuri Profile OSIS
  const profilesStock = [
    {
      id: 1,
      nume: 'Sika Euro-Design 70',
      material: 'epoxidic',
      brand: 'Sika',
      sistem: '70mm - 5 camere',
      culoare: 'Alb',
      codCuloare: 'RAL 9016',
      cantitate: 245,
      unitateMasura: 'ml',
      stocMinim: 100,
      pretUnitar: 45.50,
      valoareStoc: 11152.50,
      locatie: 'Depozit A - Raft 1-3',
      ultimaReceptie: '2024-09-01',
      status: 'optim',
      furnizor: 'Sika România SRL',
      specificatii: {
        grosimePerete: '2.8mm',
        clasaA: 'Da',
        izolareTermica: 'Uf = 1.3 W/m²K',
        izolareFonica: 'Rw = 47 dB',
        rezistentaVant: 'Clasa C5/B5',
        etanseitate: 'Clasa 4'
      },
      dimensiuniDisponibile: [
        '70x70mm - Toc fix',
        '70x85mm - Canat',
        '58x70mm - Batiant',
        '24x70mm - Parclose'
      ]
    },
    {
      id: 2,
      nume: 'Schüco AWS 75.SI',
      material: 'Aluminiu',
      brand: 'Schüco',
      sistem: '75mm - Rupere termică',
      culoare: 'Antracit',
      codCuloare: 'RAL 7016',
      cantitate: 89,
      unitateMasura: 'ml',
      stocMinim: 50,
      pretUnitar: 125.80,
      valoareStoc: 11196.20,
      locatie: 'Depozit A - Raft 7-8',
      ultimaReceptie: '2024-08-25',
      status: 'optim',
      furnizor: 'Schüco International România',
      specificatii: {
        grosimePerete: '1.5mm',
        aliaj: 'EN AW-6060-T66',
        izolareTermica: 'Uf = 1.4 W/m²K',
        izolareFonica: 'Rw = 45 dB',
        rezistentaVant: 'Clasa C5/B5',
        etanseitate: 'Clasa 4'
      },
      dimensiuniDisponibile: [
        '75x135mm - Toc fix',
        '75x150mm - Canat',
        '75x65mm - Batiant',
        '25x75mm - Parclose'
      ]
    },
    {
      id: 3,
      nume: 'BASF BluEvolution 73',
      material: 'epoxidic',
      brand: 'BASF',
      sistem: '73mm - 5 camere',
      culoare: 'Winchester',
      codCuloare: 'Dekor 2540',
      cantitate: 34,
      unitateMasura: 'ml',
      stocMinim: 80,
      pretUnitar: 68.90,
      valoareStoc: 2342.60,
      locatie: 'Depozit A - Raft 14',
      ultimaReceptie: '2024-07-20',
      status: 'scazut',
      furnizor: 'BASF România SRL',
      specificatii: {
        grosimePerete: '3.0mm',
        clasaA: 'Da',
        izolareTermica: 'Uf = 1.2 W/m²K',
        izolareFonica: 'Rw = 48 dB',
        rezistentaVant: 'Clasa C5/B5',
        etanseitate: 'Clasa 4'
      },
      dimensiuniDisponibile: [
        '73x82mm - Toc fix',
        '73x97mm - Canat',
        '61x73mm - Batiant',
        '24x73mm - Parclose'
      ]
    },
    {
      id: 4,
      nume: 'ALUPLAST IDEAL 4000',
      material: 'epoxidic',
      brand: 'ALUPLAST',
      sistem: '70mm - 5 camere',
      culoare: 'Antracit',
      codCuloare: 'RAL 7016',
      cantitate: 23,
      unitateMasura: 'ml',
      stocMinim: 60,
      pretUnitar: 49.60,
      valoareStoc: 1140.80,
      locatie: 'Depozit A - Raft 15',
      ultimaReceptie: '2024-07-15',
      status: 'critic',
      furnizor: 'ALUPLAST România SRL',
      specificatii: {
        grosimePerete: '2.8mm',
        clasaA: 'Da',
        izolareTermica: 'Uf = 1.3 W/m²K',
        izolareFonica: 'Rw = 47 dB',
        rezistentaVant: 'Clasa C5/B5',
        etanseitate: 'Clasa 4'
      },
      dimensiuniDisponibile: [
        '70x70mm - Toc fix',
        '70x85mm - Canat',
        '58x70mm - Batiant',
        '24x70mm - Parclose'
      ]
    }
  ];

  // Filtrare profile
  const filteredProfiles = profilesStock.filter(profile => {
    const matchesSearch = profile.nume.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         profile.brand.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         profile.culoare.toLowerCase().includes(searchTerm.toLowerCase());
    
    const matchesMaterial = selectedMaterial === 'toate' || profile.material === selectedMaterial;
    const matchesBrand = selectedBrand === 'toate' || profile.brand === selectedBrand;
    
    return matchesSearch && matchesMaterial && matchesBrand;
  });

  // Branduri și materiale disponibile
  const materiale = ['toate', ...new Set(profilesStock.map(p => p.material))];
  const branduri = ['toate', ...new Set(profilesStock.map(p => p.brand))];

  // Profile cu stoc scăzut
  const profileScazute = profilesStock.filter(p => p.status === 'scazut' || p.status === 'critic');

  // Statistici
  const statistici = {
    totalProfile: profilesStock.length,
    valoareTotala: profilesStock.reduce((sum, p) => sum + p.valoareStoc, 0),
    profileepoxidic: profilesStock.filter(p => p.material === 'epoxidic').length,
    profileAluminiu: profilesStock.filter(p => p.material === 'Aluminiu').length
  };

  const getStatusColor = (status) => {
    switch(status) {
      case 'optim': return 'success';
      case 'scazut': return 'warning';
      case 'critic': return 'error';
      default: return 'gray';
    }
  };

  const getMaterialColor = (material) => {
    return material === 'epoxidic' ? 'text-blue-600' : 'text-gray-600';
  };

  const handleProfileClick = (profile) => {
    setSelectedProfile(profile);
    setShowProfileModal(true);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              rășini epoxidice & Aluminiu
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Stocuri profile pentru sisteme de pardoseli industriale OSIS
            </p>
          </div>
          
          <button className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors mt-4 sm:mt-0">
            <Plus className="w-4 h-4 mr-2" />
            Adaugă Profil
          </button>
        </div>

        {/* Statistici Rapide */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-primary-100 dark:bg-primary-900 rounded-xl">
                <Layers className="w-6 h-6 text-primary-600" />
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {statistici.totalProfile}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Total Profile
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-900 rounded-xl">
                <Package className="w-6 h-6 text-green-600" />
              </div>
            </div>
            <div className="text-lg font-bold text-gray-900 dark:text-white mb-1">
              {statistici.valoareTotala.toLocaleString()} RON
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Valoare Totală
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-blue-100 dark:bg-blue-900 rounded-xl">
                <span className="text-blue-600 font-bold text-sm">epoxidic</span>
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {statistici.profileepoxidic}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              rășini epoxidice
            </p>
          </Card>

          <Card className="p-6">
            <div className="flex items-center justify-between mb-4">
              <div className="flex items-center justify-center w-12 h-12 bg-gray-100 dark:bg-gray-800 rounded-xl">
                <span className="text-gray-600 font-bold text-sm">ALU</span>
              </div>
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
              {statistici.profileAluminiu}
            </div>
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Profile Aluminiu
            </p>
          </Card>
        </div>

        {/* Alerte Stoc */}
        {profileScazute.length > 0 && (
          <Card className="p-6 mb-8 border-l-4 border-orange-500">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-semibold text-gray-900 dark:text-white flex items-center">
                <AlertTriangle className="w-5 h-5 text-orange-500 mr-2" />
                Profile cu Stoc Scăzut
              </h2>
              <Badge variant="warning">{profileScazute.length} profile</Badge>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {profileScazute.map((profile) => (
                <div key={profile.id} className="p-4 bg-orange-50 dark:bg-orange-900/30 border border-orange-200 dark:border-orange-800 rounded-lg">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-medium text-gray-900 dark:text-white text-sm">
                      {profile.brand} - {profile.culoare}
                    </h3>
                    <Badge variant={getStatusColor(profile.status)} size="sm">
                      {profile.status === 'critic' ? 'Critic' : 'Scăzut'}
                    </Badge>
                  </div>
                  <div className="text-sm text-gray-600 dark:text-gray-400">
                    <p>Stoc: <span className="font-medium">{profile.cantitate} {profile.unitateMasura}</span></p>
                    <p>Minim: <span className="font-medium">{profile.stocMinim} {profile.unitateMasura}</span></p>
                  </div>
                </div>
              ))}
            </div>
          </Card>
        )}

        {/* Filtre */}
        <Card className="p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="relative">
              <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Caută după brand, nume sau culoare..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
            </div>
            
            <select
              value={selectedMaterial}
              onChange={(e) => setSelectedMaterial(e.target.value)}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              {materiale.map((material) => (
                <option key={material} value={material}>
                  {material === 'toate' ? 'Toate materialele' : material}
                </option>
              ))}
            </select>
            
            <select
              value={selectedBrand}
              onChange={(e) => setSelectedBrand(e.target.value)}
              className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
            >
              {branduri.map((brand) => (
                <option key={brand} value={brand}>
                  {brand === 'toate' ? 'Toate mărcile' : brand}
                </option>
              ))}
            </select>
          </div>
        </Card>

        {/* Lista Profile */}
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
          {filteredProfiles.map((profile) => (
            <Card 
              key={profile.id} 
              className="p-6 hover:shadow-lg transition-all cursor-pointer"
              onClick={() => handleProfileClick(profile)}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center space-x-2">
                  <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${
                    profile.material === 'epoxidic' ? 'bg-blue-100 dark:bg-blue-900' : 'bg-gray-100 dark:bg-gray-800'
                  }`}>
                    <span className={`font-bold text-sm ${getMaterialColor(profile.material)}`}>
                      {profile.material}
                    </span>
                  </div>
                  <Badge variant={getStatusColor(profile.status)} size="sm">
                    {profile.status === 'optim' ? 'Optim' : profile.status === 'scazut' ? 'Scăzut' : 'Critic'}
                  </Badge>
                </div>
                
                <button className="p-1 text-gray-400 hover:text-primary-600 transition-colors">
                  <Eye className="w-4 h-4" />
                </button>
              </div>

              <div className="mb-4">
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-1">
                  {profile.brand} {profile.nume}
                </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {profile.sistem} • {profile.culoare}
                </p>
              </div>

              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Stoc actual</p>
                  <p className="text-xl font-bold text-gray-900 dark:text-white">
                    {profile.cantitate} {profile.unitateMasura}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-600 dark:text-gray-400">Valoare stoc</p>
                  <p className="text-xl font-bold text-primary-600">
                    {profile.valoareStoc.toLocaleString()} RON
                  </p>
                </div>
              </div>

              <div className="flex items-center justify-between text-sm text-gray-600 dark:text-gray-400">
                <span>{profile.locatie}</span>
                <span>Min: {profile.stocMinim}</span>
              </div>

              {/* Bara progres stoc */}
              <div className="mt-3">
                <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-2">
                  <div 
                    className={`h-2 rounded-full transition-all duration-500 ${
                      profile.status === 'optim' ? 'bg-green-500' :
                      profile.status === 'scazut' ? 'bg-yellow-500' :
                      'bg-red-500'
                    }`}
                    style={{ width: `${Math.min((profile.cantitate / (profile.stocMinim * 2)) * 100, 100)}%` }}
                  />
                </div>
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>0</span>
                  <span>Optim: {profile.stocMinim * 2}</span>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {filteredProfiles.length === 0 && (
          <Card className="p-12 text-center">
            <Layers className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
              Niciun profil găsit
            </h3>
            <p className="text-gray-600 dark:text-gray-400">
              Încearcă să modifici criteriile de căutare sau filtrare
            </p>
          </Card>
        )}
      </div>

      {/* Modal Detalii Profil */}
      <Modal isOpen={showProfileModal} onClose={() => setShowProfileModal(false)}>
        {selectedProfile && (
          <div className="p-6 max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <div>
                <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-1">
                  {selectedProfile.brand} {selectedProfile.nume}
                </h2>
                <p className="text-gray-600 dark:text-gray-400">
                  {selectedProfile.sistem} • {selectedProfile.culoare}
                </p>
              </div>
              <div className="flex items-center space-x-2">
                <Badge variant={selectedProfile.material === 'epoxidic' ? 'primary' : 'secondary'}>
                  {selectedProfile.material}
                </Badge>
                <Badge variant={getStatusColor(selectedProfile.status)}>
                  {selectedProfile.status === 'optim' ? 'Stoc Optim' : 
                   selectedProfile.status === 'scazut' ? 'Stoc Scăzut' : 'Stoc Critic'}
                </Badge>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
              {/* Informații Stoc */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Informații Stoc</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Cantitate:</span>
                    <span className="font-bold text-gray-900 dark:text-white">
                      {selectedProfile.cantitate} {selectedProfile.unitateMasura}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Stoc minim:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedProfile.stocMinim} {selectedProfile.unitateMasura}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Preț unitar:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedProfile.pretUnitar.toFixed(2)} RON
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Valoare totală:</span>
                    <span className="font-bold text-primary-600">
                      {selectedProfile.valoareStoc.toLocaleString()} RON
                    </span>
                  </div>
                </div>
              </Card>

              {/* Informații Furnizor */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Furnizor & Locație</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Furnizor:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedProfile.furnizor}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Locație:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedProfile.locatie}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Ultima recepție:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {new Date(selectedProfile.ultimaReceptie).toLocaleDateString('ro-RO')}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 dark:text-gray-400">Cod culoare:</span>
                    <span className="font-medium text-gray-900 dark:text-white">
                      {selectedProfile.codCuloare}
                    </span>
                  </div>
                </div>
              </Card>

              {/* Specificații Tehnice */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Specificații Tehnice</h3>
                <div className="space-y-2 text-sm">
                  {Object.entries(selectedProfile.specificatii).map(([key, value]) => (
                    <div key={key} className="flex justify-between">
                      <span className="text-gray-600 dark:text-gray-400 capitalize">
                        {key.replace(/([A-Z])/g, ' $1').trim()}:
                      </span>
                      <span className="font-medium text-gray-900 dark:text-white text-right max-w-[60%]">
                        {value}
                      </span>
                    </div>
                  ))}
                </div>
              </Card>
            </div>

            {/* Dimensiuni Disponibile */}
            <Card className="p-4 mb-6">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Dimensiuni Disponibile</h3>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {selectedProfile.dimensiuniDisponibile.map((dimensiune, index) => (
                  <div key={index} className="p-3 bg-gray-50 dark:bg-gray-800 rounded-lg text-center">
                    <span className="text-sm font-medium text-gray-900 dark:text-white">
                      {dimensiune}
                    </span>
                  </div>
                ))}
              </div>
            </Card>

            <div className="flex justify-end space-x-3">
              <button className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                Istoric Mișcări
              </button>
              <button className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
                Comandă Urgent
              </button>
              <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
                Editează Profil
              </button>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ProfilesStock;